import PropTypes from 'prop-types';
import React from 'react';
import ResponseBox from './ResponseBox';
import {
    DAZE_BREAK, RESPONSE_GAP, ESCAPE_QUOTE, DAZE_ITALIC_END, DAZE_ITALIC_START,
} from '../../constants/regExp';

// TODO maybe refactor this somewhere in the future
/* eslint-disable react/no-multi-comp */
const ClozeText = (props) => {
    const getResponseOptions = (questionIndexStr) => {
        const questionIndex = parseInt(questionIndexStr, 10);
        const question = props.questions[questionIndex];
        return (
            <ResponseBox
                isTabIndexActive={props.isTabIndexActive}
                questionId={question.id}
                key={question.id}
                options={question.possibleResponses}
                selectedId={props.selectedResponses[question.id]}
                onResponseSelected={props.onResponseSelected} />
        );
    };
    const getTextWithBreak = (line, lineIndex) => line.split(DAZE_BREAK).map((el, i, arr) => {
        const divider = i < (arr.length - 1) ? <br /> : null;
        /* eslint-disable react/no-array-index-key */
        return (
            <span key={`text-${lineIndex}-${i}`}>
                {el}
                {divider}
            </span>
        );
    });
    const getParsedHTML = (snippet) => {
        const text = snippet
            .replace(DAZE_ITALIC_START, '<i>')
            .replace(DAZE_ITALIC_END, '</i>');
        // TODO replace this implementation with non-dangerous way
        // eslint-disable-next-line react/no-danger
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
    };
    const paragraphWithGaps = props.text.replace(ESCAPE_QUOTE, '"')
        .split(RESPONSE_GAP).map((snippet, i) => {
            // placeholder numbers a 2-digit, hence we have 'len > 2' condition
            // to exclude text pieces with legit numbers - they will have greater length (e.g. ' 1 ' or ' 20 ')
            if (snippet.length === 0 || snippet.length > 2 || Number.isNaN(+snippet)) {
                if (snippet.match(DAZE_BREAK)) {
                    return getTextWithBreak(snippet, i);
                }
                /* eslint-disable react/no-array-index-key */
                return <span key={`text-${i}`}>{getParsedHTML(snippet)}</span>;
            }
            return getResponseOptions(snippet);
        });
    return (
        <div>{paragraphWithGaps}</div>
    );
};

export default ClozeText;

/* eslint-disable react/no-unused-prop-types */
ClozeText.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.object).isRequired,
    text: PropTypes.string.isRequired,
    selectedResponses: PropTypes.object,
    onResponseSelected: PropTypes.func,
    isTabIndexActive: PropTypes.bool,
};
/* eslint-disable react/no-unused-prop-types */

ClozeText.defaultProps = {
    selectedResponses: {},
    onResponseSelected: () => { },
    isTabIndexActive: true
};
